export const vertexShader = `
attribute float size;
attribute vec2 textureUV;
attribute vec3 customColor;
#define PI 3.1415926538

attribute float myIndex;
attribute float siblingsStart;
attribute float siblingsEnd;
attribute vec3 mode0PosInit;
attribute float mode0Radius;
attribute vec3 mode0Centroid;
attribute float mode0Speed;
attribute float mode0DeltaStart;

attribute float mode1CommunityID;
attribute vec3 mode1Position;
attribute float mode1IsNode;
attribute float mode1IsEdgeNode;
attribute float mode1ID;

uniform float animationDelta;
uniform sampler2D dataTexture;
uniform float mode;
uniform float lerpPercent;
uniform vec3 origin;
uniform vec3 direction;
uniform float isInteracting;

uniform sampler2D sphere0Texture;
uniform sampler2D sphere1Texture;
uniform sampler2D sphere2Texture;

uniform vec2 sphere0UV;
uniform vec2 sphere1UV;
uniform vec2 sphere2UV;

uniform float sphere0Size;
uniform float sphere0Dimensions;
uniform float sphere0AnimationDelta;

uniform float sphere1Size;
uniform float sphere1Dimensions;
uniform float sphere1AnimationDelta;

uniform float sphere2Size;
uniform float sphere2Dimensions;
uniform float sphere2AnimationDelta;

varying vec3 vColor;
varying float distToCamera;
varying float isVisible;
varying float renderMode;
varying float useTexture;
vec3 v3PosNow;

vec3 findClosestPoint(vec3 v3Pos) {
    
	vec3 target = v3Pos - origin;
	float distance = dot(target, direction);
	return direction * distance + origin;

}

float modI(float a,float b) {
	//a - (b * floor(a/b))
	return a - (b * floor(a/b));
    //float m=a-floor((a+0.5)/b)*b;
    //return floor(m+0.5);
}


void main() {
	useTexture = 0.0;
	if(animationDelta > 0.0){
		isVisible = 1.0;
	}
	else{
		isVisible = 0.0;
	}
	renderMode = mode;
	if(mode <= 0.1){
		isVisible = 1.0;
		//isVisible = mix(0.0,0.0,lerpPercent);

		float deltaMult = 0.005;
		if(mode1IsEdgeNode == 0.0 && mode1IsNode == 1.0){
			deltaMult = mix(0.001,0.000,lerpPercent);
		}
		float deltaAdd = (animationDelta * deltaMult * (PI*2.0) * mode0Speed) + mode0DeltaStart;
		//vec3 v3PosNow = mode0Centroid + vec3(  cos(deltaAdd) * mode0Radius,0.0,  sin(deltaAdd) * mode0Radius );
		float modPos = modI(myIndex,3.0);
		vec3 m0Centroid = mode0Centroid;
		if(mode1IsEdgeNode == 0.0 && mode1IsNode == 1.0){
			m0Centroid = mix(mode0Centroid,mode1Position,lerpPercent);
		}
		if(modPos == 0.0){
			v3PosNow = m0Centroid + vec3(  (sin(deltaAdd) * cos(mode0Radius)) * mode0Radius,(sin(deltaAdd) * sin(mode0Radius)) * mode0Radius,  cos(deltaAdd) * mode0Radius );
		}
		if(modPos == 1.0){
			v3PosNow = m0Centroid + vec3(cos(deltaAdd) * mode0Radius ,  (sin(deltaAdd) * sin(mode0Radius)) * mode0Radius,(sin(deltaAdd) * cos(mode0Radius)) * mode0Radius);
		}
		if(modPos == 2.0){
			v3PosNow = m0Centroid + vec3(  (sin(deltaAdd) * sin(mode0Radius)) * mode0Radius,(sin(deltaAdd) * cos(mode0Radius)) * mode0Radius,  cos(deltaAdd) * mode0Radius );
		
		}
		//vColor = customColor;
		vec3 tmpPos = v3PosNow;
		vec4 mvPosition = modelViewMatrix * vec4( tmpPos.xyz, 1.0 );

		//mv1 mix
		vec3 tmpPosM1 = vec3(mode1Position.x,mode1Position.y,mode1Position.z);
		vec4 mvPositionM1 = modelViewMatrix * vec4( tmpPosM1.xyz, 1.0 );
		if(mode1IsEdgeNode == 0.0 && mode1IsNode == 1.0){
			//mvPosition = mix(mvPosition,mvPositionM1,lerpPercent);
		}
		else{
			mvPosition = mix(mvPosition,mvPositionM1,lerpPercent);
		}
		

		vec4 cs_position = modelViewMatrix * vec4(tmpPos.xyz,1.0);
		vColor = vec3(0.85,0.95,1.0) * (1.0-mode0Speed);
	    distToCamera = length(cs_position.xyz);
	    if(mode1IsEdgeNode == 1.0 && mode1IsNode == 1.0){
			vColor = mix(vColor,vec3(0.55,0.65,0.7),lerpPercent);
	    	isVisible = mix(0.0,mode1IsNode,lerpPercent);

			if (lerpPercent > 0.9) {
				isVisible = 0.9;
			}
			if (lerpPercent > 0.91) {
				isVisible = 0.8;
			}
			if (lerpPercent > 0.92) {
				isVisible = 0.7;
			}
			if (lerpPercent > 0.93) {
				isVisible = 0.6;
			}
			if (lerpPercent > 0.94) {
				isVisible = 0.5;
			}
			if (lerpPercent > 0.95) {
				isVisible = 0.4;
			}
			if (lerpPercent > 0.96) {
				isVisible = 0.3;
			}
			if (lerpPercent > 0.97) {
				isVisible = 0.2;
			}
			if (lerpPercent > 0.98) {
				isVisible = 0.1;
			}
			if (lerpPercent > 0.99) {
				isVisible = 0.0;
			}
		}
		if(mode1IsEdgeNode == 0.0){
			isVisible = mix(isVisible,0.1,lerpPercent);
		}

	    float pointSize0 = size * ( 300.0 / -mvPosition.z ) * (1.0+mode0Speed);
	    float pointSize1 = size * ( 300.0 / -mvPosition.z ) * (20.0 * isVisible);
	    if(isInteracting > 0.1){
		    vec3 unprojectedPos = mix(tmpPos,tmpPosM1,lerpPercent);
		    vec3 cp2p = findClosestPoint(unprojectedPos.xyz);
		    float distLen = length(unprojectedPos.xyz - cp2p);
		    if (distLen < 20.0){
		    	vColor = mix(vColor,(vec3(0.03137254901960784,0.9137254901960784,0.7372549019607844)),distLen/20.0*0.218);
		    	mvPosition = mix((modelViewMatrix * vec4(cp2p,1.0)),mvPosition,distLen / 20.0);
		    }
		}

		gl_PointSize = mix(pointSize0,pointSize1,lerpPercent);



		gl_Position = projectionMatrix * mvPosition;
	}
	if(mode >= 0.9 && mode < 2.0){
		isVisible = mode1IsNode;
		vec3 tmpPos = vec3(mode1Position.x,mode1Position.y,mode1Position.z);
		vColor = vec3(1.0,1.0,1.0);
		
	    
	    vec4 cs_position = modelViewMatrix * vec4(tmpPos.xyz,1.0);
		vColor = vec3(0.85,0.95,1.0) * (0.9-mode0Speed);
	    distToCamera = length(cs_position.xyz);

	    vec4 mvPosition = modelViewMatrix * vec4( tmpPos.xyz, 1.0 );

	    if(mode1IsEdgeNode == 1.0){
	    	//is a node in the network graph
	    	vColor = vec3(0.55,0.65,0.7);
	    }

	    //mode2 calc
	    /*

		//introduces too much wiggle on the points during the initial transition from graph to contour plot
		
			float tX = floor(modI(myIndex , 256.0));
			float tY = floor(myIndex / 256.0);
			vec3 vColorM2 = customColor;
			vColor = mix(vColor,vColorM2,lerpPercent);
			vec2 vuv = vec2(tX/256.0,tY/256.0);
			vec4 tmpPosM2 = texture2D( dataTexture, vuv );

		*/

		// float modPos = modI(myIndex,3.0);
		// if(modPos == 0.0){
		// 	tmpPosM2 = vec3(150,-50,-37) ; //end position on contour line frozen in time.
		// }
		// if(modPos == 1.0){
		// 	tmpPosM2 = vec3(150,-143,-57) ; //end position on contour line frozen in time.

		// }
		// if(modPos == 2.0){
		// 	tmpPosM2 = vec3(250,30,-37) ; //end position on contour line frozen in time.
		// }

		

		vec3 tmpPosM2 = vec3(100,-75,-50) ; //end position on contour line frozen in time.
		vec3 vColorM2 = customColor;
		vColor = mix(vColor,vColorM2,lerpPercent);
		vec4 mvPositionM2 = modelViewMatrix * vec4(  vec3(200,-75,0).xyz, 0.5 );
		if(mode1IsNode == 1.0){
			isVisible = mix(.1,0.1,lerpPercent);
		}
		if(mode1IsNode == 0.0){
			isVisible = mix(0.0,0.1,lerpPercent);
		}
		if(mode1IsEdgeNode == 1.0 || mode1IsNode == 1.0){
			isVisible = mix(0.5,0.5,lerpPercent);
			float deltaAdd = (animationDelta * 0.05 * (PI*2.0) * mode0Speed) + mode0DeltaStart;
			float modPos = modI(myIndex,3.0);
			// vec3 m0Centroid = mix(vec3(100,0,0),tmpPosM2.xyz,lerpPercent);
			vec3 m0Centroid = mix(tmpPosM2.xyz,vec3(100,-75,-25),lerpPercent);

			float m0RadPart = mix(0.01,0.5,lerpPercent); //fraction of orbit in start of transition
			float deltaAddPart = mix(0.01,0.5,lerpPercent); //fraction of orbit in start of transition
			float sizePart = mix(0.75,1.0,lerpPercent); //fraction of size in start of transition

			//left sphere
			if(modPos == 0.0){
				float x = modI(sphere0AnimationDelta,sphere0Dimensions);
		        float y = floor(sphere0AnimationDelta/sphere0Dimensions);
		        vec2 s0UV = vec2(x/sphere0Dimensions,y/sphere0Dimensions);
				vec4 fromTexture = texture2D( sphere0Texture, s0UV );
				vec4 mvPositionM2 = modelViewMatrix * vec4(  fromTexture.xyz, 1.0 );
				//vec4 mvPositionM2 = modelViewMatrix * vec4(  vec3(200,20,-25).xyz, 1.0 ); //use dynamic position from datatexture instead
				vec3 m0Centroid = mix(mode1Position,position.xyz,lerpPercent);
				v3PosNow = m0Centroid + vec3(  (sin(deltaAdd*deltaAddPart) * cos(mode0Radius*m0RadPart)) * mode0Radius*m0RadPart,(sin(deltaAdd*deltaAddPart) * sin(mode0Radius*m0RadPart)) * mode0Radius*m0RadPart,  cos(deltaAdd*deltaAddPart) * mode0Radius*m0RadPart );
				mvPosition = modelViewMatrix * vec4(v3PosNow.xyz,1.0);
				tmpPos = v3PosNow;
				//if(lerpPercent >= 0.001){
					useTexture = 1.0;
				//}
				gl_PointSize = size * ( (400.0*sizePart) / -mvPosition.z ) * (mix(20.0,10.0,lerpPercent));
				//make the early part of the transition not move so much over the dynamic pos of the topo mvPositionM2 point
				gl_Position = projectionMatrix * mix(mvPosition,mix(mvPosition,mvPositionM2,lerpPercent),lerpPercent);
				//gl_Position = projectionMatrix * mix(mvPosition,mvPositionM2,lerpPercent);
			}

			// middle sphere
			if(modPos == 1.0){
				float x = modI(sphere1AnimationDelta,sphere1Dimensions);
		        float y = floor(sphere1AnimationDelta/sphere1Dimensions);
		        vec2 s1UV = vec2(x/sphere1Dimensions,y/sphere1Dimensions);
				vec4 fromTexture = texture2D( sphere1Texture, s1UV );
				vec4 mvPositionM2 = modelViewMatrix * vec4(  fromTexture.xyz, 1.0 );

				//vec4 mvPositionM2 = modelViewMatrix * vec4(  vec3(200,-55,-55).xyz, 1.0 ); //use dynamic position from datatexture instead
				vec3 m0Centroid = mix(mode1Position,position.xyz,lerpPercent);
				v3PosNow =  m0Centroid + vec3(cos(deltaAdd*deltaAddPart) * mode0Radius*m0RadPart ,  (sin(deltaAdd*deltaAddPart) * sin(mode0Radius*m0RadPart)) * mode0Radius*m0RadPart,(sin(deltaAdd*deltaAddPart) * cos(mode0Radius*m0RadPart)) * mode0Radius*m0RadPart);
				mvPosition = modelViewMatrix * vec4(v3PosNow.xyz,1.0);
				tmpPos = v3PosNow;
				//if(lerpPercent >= 0.001){
					useTexture = 1.0;
				//}
				gl_PointSize = size * ( (400.0*sizePart) / -mvPosition.z ) * (mix(20.0,10.0,lerpPercent));
				//make the early part of the transition not move so much over the dynamic pos of the topo mvPositionM2 point
				gl_Position = projectionMatrix * mix(mvPosition,mix(mvPosition,mvPositionM2,lerpPercent),lerpPercent);
				//gl_Position = projectionMatrix * mix(mvPosition,mvPositionM2,lerpPercent);
			}

			// right sphere
			if(modPos == 2.0){
				float x = modI(sphere2AnimationDelta,sphere2Dimensions);
		        float y = floor(sphere2AnimationDelta/sphere2Dimensions);
		        vec2 s2UV = vec2(x/sphere2Dimensions,y/sphere2Dimensions);
				vec4 fromTexture = texture2D( sphere2Texture, s2UV );
				vec4 mvPositionM2 = modelViewMatrix * vec4(  fromTexture.xyz, 1.0 );

				//vec4 mvPositionM2 = modelViewMatrix * vec4(  vec3(200,-180,-75).xyz, 1.0 ); //use dynamic position from datatexture instead
				vec3 m0Centroid = mix(mode1Position,position.xyz,lerpPercent);
				v3PosNow = m0Centroid+ vec3(  (sin(deltaAdd*deltaAddPart) * sin(mode0Radius*m0RadPart)) * mode0Radius*m0RadPart,(sin(deltaAdd*deltaAddPart) * cos(mode0Radius*m0RadPart)) * mode0Radius*m0RadPart,  cos(deltaAdd*deltaAddPart) * mode0Radius*m0RadPart );
				mvPosition = modelViewMatrix * vec4(v3PosNow.xyz,1.0);
				tmpPos = v3PosNow;
				//if(lerpPercent >= 0.001){
					useTexture = 1.0;
				//}
				gl_PointSize = size * ( (400.0*sizePart) / -mvPosition.z ) * (mix(20.0,10.0,lerpPercent));
				//make the early part of the transition not move so much over the dynamic pos of the topo mvPositionM2 point
				gl_Position = projectionMatrix * mix(mvPosition,mix(mvPosition,mvPositionM2,lerpPercent),lerpPercent);
				//gl_Position = projectionMatrix * mix(mvPosition,mvPositionM2,lerpPercent);
			}
		}
		if(isInteracting > 0.1){
				vec3 unprojectedPos = mix(tmpPos,tmpPosM2,lerpPercent);
			    vec3 cp2p = findClosestPoint(unprojectedPos.xyz);
			    float distLen = length(unprojectedPos.xyz - cp2p);
			    if (distLen < 20.0){
			    	vColor = mix(vColor,(vec3(0.03137254901960784,0.9137254901960784,0.7372549019607844)),distLen/20.0*0.618);
			    	mvPosition = mix((modelViewMatrix * vec4(cp2p,1.0)),mvPosition,distLen / 20.0);
			    }
			}
	


	}
	if(mode >= 1.9){
		//for glowing orbs instead of spheres, 
		//1. we transition from the end point of the network graph to the point on the topographic contour path
		//2. we pass in data textures of the 3 topographic contour paths, and position
		//3. based on the pointID % 3 we set our point somewhere near the place on the topographic contour path

		if(mode1IsEdgeNode == 1.0 || mode1IsNode == 1.0){
			vec3 posMultiplier = vec3(1.0,1.0,1.0);
			float modPos = modI(myIndex,3.0);
			useTexture = 1.0;
			isVisible = mode1IsNode;
			vec3 tmpPos = vec3(0.0,0.0,0.0);
			if(modPos == 0.0){
				
		        float x = modI(sphere0AnimationDelta,sphere0Dimensions);
		        float y = floor(sphere0AnimationDelta/sphere0Dimensions);
		        vec2 s0UV = vec2(x/sphere0Dimensions,y/sphere0Dimensions);

				vec4 fromTexture = texture2D( sphere0Texture, s0UV );
				tmpPos = fromTexture.xyz;
				//tmpPos = vec3(200,20,-25); //use dynamic position from datatexture instead
			}
			if(modPos == 1.0){
				float x = modI(sphere1AnimationDelta,sphere1Dimensions);
		        float y = floor(sphere1AnimationDelta/sphere1Dimensions);
		        vec2 s1UV = vec2(x/sphere1Dimensions,y/sphere1Dimensions);
				vec4 fromTexture = texture2D( sphere1Texture, s1UV );
				tmpPos = fromTexture.xyz;
				//tmpPos = vec3(200,-55,-55); //use dynamic position from datatexture instead
				
			}
			if(modPos == 2.0){
				float x = modI(sphere2AnimationDelta,sphere2Dimensions);
		        float y = floor(sphere2AnimationDelta/sphere2Dimensions);
		        vec2 s2UV = vec2(x/sphere2Dimensions,y/sphere2Dimensions);
				vec4 fromTexture = texture2D( sphere2Texture, s2UV );
				tmpPos = fromTexture.xyz;
				//tmpPos = vec3(200,-180,-75); //use dynamic position from datatexture instead
			}

			//this basically creates a 3d orbit near the centroid of where we want to be on the sphere path
			//thus giving us this glowing orb effect that's cheaper than any zoom/blur shader + render pass

			float deltaMult = 0.25;
			float deltaAdd = (animationDelta * 0.05 * (PI*2.0) * mode0Speed) + mode0DeltaStart;
			float m0RadPart = 0.25;//mix(0.01,0.5,lerpPercent); //fraction of orbit in start of transition
			float deltaAddPart = 0.25;//mix(0.01,0.5,lerpPercent); //fraction of orbit in start of transition
			
			tmpPos = tmpPos * posMultiplier;
			vec4 mvPositionM2 = modelViewMatrix * vec4(  tmpPos.xyz, 1.0 );
			vec3 m0Centroid = mix(tmpPos.xyz,position.xyz,0.9+(0.1*lerpPercent));
			v3PosNow = m0Centroid + vec3(  (sin(deltaAdd*deltaAddPart) * sin(mode0Radius*m0RadPart)) * mode0Radius*m0RadPart,(sin(deltaAdd*deltaAddPart) * cos(mode0Radius*m0RadPart)) * mode0Radius*m0RadPart,  cos(deltaAdd*deltaAddPart) * mode0Radius*m0RadPart );
			v3PosNow = v3PosNow * posMultiplier;
			vec4 mvPosition = modelViewMatrix * vec4(v3PosNow.xyz,1.0);
			tmpPos = v3PosNow;




			vColor = customColor;
			vec4 cs_position = modelViewMatrix * vec4(tmpPos.xyz,1.0);
		    distToCamera = length(cs_position.xyz);
		    float sizeLerp = mix(1.0,0.5,lerpPercent);
			gl_PointSize = (size) * ( (400.0*sizeLerp) / -mvPosition.z ) * (mix(20.0,10.0,lerpPercent));

			gl_Position = projectionMatrix * mix(mvPosition,mvPositionM2,0.90+(0.1*lerpPercent));
		}
	}

}
`